import { render, staticRenderFns } from "./add_correction.vue?vue&type=template&id=9a625e52&scoped=true&"
import script from "./add_correction.vue?vue&type=script&lang=js&"
export * from "./add_correction.vue?vue&type=script&lang=js&"
import style0 from "./add_correction.vue?vue&type=style&index=0&id=9a625e52&lang=less&scoped=true&"
import style1 from "./add_correction.vue?vue&type=style&index=1&id=9a625e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a625e52",
  null
  
)

export default component.exports